import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { SwiperDirective } from 'src/app/shared/directives/swiper.directive';

import { SwiperOptions } from 'swiper/types/swiper-options';

import { HotelCardMobileComponent } from '../hotel-card-mobile/hotel-card-mobile.component';
import { HotelsMapComponent } from '../../../../../shared/maps/hotels-map/hotels-map.component';

@Component({
  selector: 'app-hotel-map-mobile',
  templateUrl: './hotel-map-mobile.component.html',
  styleUrls: ['hotel-map-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SwiperDirective, HotelsMapComponent, HotelCardMobileComponent],
})
export class HotelListMobileComponent implements OnInit, AfterViewInit {
  @Input() countryName: string = '';
  @Input() cityName: string = '';
  @Input() cityId: string | number = '';
  @Input() hotels: any[] = [];
  @ViewChild(SwiperDirective) swiper!: SwiperDirective;
  protected currentHotels: any[] = [];
  protected readonly swiperOptions: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 16,
    on: {
      slideChange: () => this.onSlideChange(),
    },
  };
  private currentBlockIndex: number = 0;
  private isFirstChange: boolean = true;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.currentHotels = this.hotels.slice(
      this.currentBlockIndex * 6,
      (this.currentBlockIndex + 1) * 6,
    );
  }

  ngAfterViewInit() {
    this.onSlideChange();
  }

  public onSlideChange(): void {
    const currentIndex = this.swiper.swiperInstance?.activeIndex || 0;

    const newBlockIndex = Math.floor(currentIndex / 6);

    if (this.isFirstChange || newBlockIndex !== this.currentBlockIndex) {
      this.isFirstChange = false;
      this.currentBlockIndex = newBlockIndex;
      this.currentHotels = this.hotels.slice(
        this.currentBlockIndex * 6,
        (this.currentBlockIndex + 1) * 6,
      );
      this.cdr.markForCheck();
    }
  }

  public scrollToHotel(hotelId: number): void {
    if (this.swiper && this.swiper.swiperInstance) {
      const hotelIndex = this.hotels.findIndex((h) => h.id === hotelId);
      if (hotelIndex > -1) {
        this.swiper.swiperInstance.slideTo(hotelIndex);
      }
    }
  }
}
